import React from 'react';
import { manufacturingCapabilities, images } from '../data/mock';
import { ArrowRight } from 'lucide-react';

const CapabilitiesSection = ({ onRequestQuote }) => {
  const sections = [
    { title: 'Precision Machines', data: manufacturingCapabilities.precision_machines },
    { title: 'Plating Setup', data: manufacturingCapabilities.plating_setup },
    { title: 'Rectifiers', data: manufacturingCapabilities.rectifiers_setup },
    { title: 'Support Equipment', data: manufacturingCapabilities.support_equipment }
  ];

  return (
    <section id="capabilities" className="section-padding" style={{ background: 'var(--bg-primary)' }}>
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <div className="section-header" style={{ marginBottom: 0 }}>
              <p className="section-label">Manufacturing Capabilities</p>
              <h2 className="section-title">State-of-the-Art Equipment</h2>
              <p className="section-description">
                Our facility is equipped with modern machinery to ensure precision, 
                efficiency, and consistent quality in every batch.
              </p>
            </div>
          </div>
          <div className="image-overlay-container hidden lg:block" style={{ height: '280px' }}>
            <img 
              src={images.machinery}
              alt={images.machineryAlt}
              className="img-cover"
              loading="lazy"
            />
            <div className="image-overlay" />
          </div>
        </div>

        <div className="capabilities-grid">
          {sections.map((section, index) => (
            <div key={index} className="capability-section">
              <h3 className="capability-title">{section.title}</h3>
              {section.data.map((item, idx) => (
                <div key={idx} className="capability-item">
                  <span className="capability-name">{item.name}</span>
                  <span className="capability-qty">{String(item.qty).padStart(2, '0')}</span>
                </div>
              ))}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="btn-text" onClick={onRequestQuote}>
            Request Capabilities PDF
            <ArrowRight size={14} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default CapabilitiesSection;
